export class JobChoiceAttribute {
    public id: number;
    public jobChoiceId: number;
    public attributeGroupCommunityId: number;
    public attributeCommunityId: number;
    public attributeName: string;
    public attributeGroupLabel: string;
    public manufacturer: string;
    public sku: string;
    public attributeGroupLabelDisplay: string;
    public isAttributeReassigned: boolean;
}
